<template>
    <div id="menuHeaderAdmin" class="flexContainer ai-c jc-sb m-jc-fs m-fd-r">
        <h1 class="titleSandBox">SANDBOX</h1>
        <div class="flexContainer jc-sb ai-c ac-c linksWrapper mobileNot center">
            <h3 class="message txtCenter">{{ $t("sandbox.message") }}</h3>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    data: () => ({
        test: false
    }),
    components: {},
    methods: {},
    computed: {
        ...mapGetters({
            getBrand: "brand/getBrand",
            getLogoRem3rch: "brand/getLogoRem3rch",
            getBackgroundColor: "brand/getBackgroundColor"
        })
    },
    created() {}
};
</script>
<style scoped lang="scss">
.message {
    color: #fff;
}
.titleSandBox {
    font-size: 30px;
    color: #fff;
    padding-left: 20px;
    font-family: "Oswald", Sans-Serif;
}
#menuHeaderAdmin {
    position: relative;
    height: 45px;
    background-color: #599bbb;
    .linksWrapper {
        font-size: 1.4rem;
        div {
            border-right: 1px solid #599bbb;
            height: 45px;
            padding-top: 15px;
            a {
                color: white;
                text-transform: uppercase;
                text-decoration: none;
                margin: 0 20px;
                padding-top: 7%;
                &:hover {
                    color: white;
                    transition: all 0.3s;
                }
                &:first-child {
                    border: none;
                }
            }
            .router-link-active {
                color: white;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// HeaderSandBox.vue?09c3f598